module.exports = __webpack_public_path__ + "img/Congratulations.a80e319e.png";